import {getCsrfToken} from './csrf' 

export const accountsApi = {
    /**
     * @param {Object} credentials { username, password }
     */

    login: async ({ username, password }) => {
        const csrfToken = getCsrfToken()
        const res = await fetch('/api/accounts/login/', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify({ username, password }),
        })

        if (!res.ok) {
            const data = await res.json().catch(() => ({}))
            throw new Error(data.detail || 'Login failed')
        }

        return res.json()
    },

    /**
     * Logout user
     */
    logout: async () => {
        const csrfToken = getCsrfToken()
        const res = await fetch('/api/accounts/logout/', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
        })

        if (!res.ok) {
            throw new Error('Logout failed')
        }

        return res.json()
    },

    /**
     * Get current user
     */
    user: async () => {
        const res = await fetch('/api/accounts/user/', {
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
            },
        })

        if (!res.ok) return null
    
        return res.json()
    },
}

